import { environment } from '../environments/environment';

export class ConfigApi {
  //live server host
  public static BASE_URL = environment.api_URL;

  public static SHOW_RECORDS = 500;
  //table configs
  public static TABLE_LENGTH_OBJ = [
    { label: 50, value: 50 },
    { label: 100, value: 100 },
    { label: 150, value: 150 },
    { label: 250, value: 250 },
    { label: 500, value: 500 },
  ];

  //APP NAME FOR TAB TITLE
  public static APP_NAME = 'JBN Fuel Distribution System';

  public static URLS: any = {
    //auth
    LOGIN: this.BASE_URL + 'api/User/Login',
    LOGOUT: this.BASE_URL + 'api/User/LogOut',

    //DROPDOWN MASTER
    GET_COMPANY: this.BASE_URL + 'api/Combo/GetCompany',
    GET_REGION: this.BASE_URL + 'api/Combo/GetRegion',
    GET_AREA: this.BASE_URL + 'api/Combo/GetArea',
    GET_SITE: this.BASE_URL + 'api/Combo/GetSite',
    GET_FLEET: this.BASE_URL + 'api/Combo/GetFleetCode',
    GET_DU_ATG_FLEET: this.BASE_URL + 'api/Combo/GetDuAtgFleetCode',
    GET_COUNTRYCODE: this.BASE_URL + 'api/Combo/GetCountryCode',
    GET_WBS: this.BASE_URL + 'api/Combo/CostWebMaster',
    GET_COSTCENTER: this.BASE_URL + 'api/Combo/CostCenterMaster',
    GET_USERTYPE: this.BASE_URL + 'api/Combo/UserTypeList',
    GET_ROLE: this.BASE_URL + 'api/Combo/RoleList',
    GET_ROLE_TYPE: this.BASE_URL + 'api/Combo/GetRoleType',
    GET_USERLOGINWITH: this.BASE_URL + 'api/Combo/UserLoginWith',
    GET_EMPLOYEE: this.BASE_URL + 'api/Combo/GetEmployeeCode',
    GET_FLEET_DIP_READING: this.BASE_URL + 'api/Combo/GetAtg',
    GET_ATG_MAPPING_DROPDOWN: this.BASE_URL + 'api/Combo/AtgMappingDropDown',
    GET_USERACTIVITY: this.BASE_URL + 'api/Combo/GetUserActivity',
    GET_ACTIVITY_PAGE: this.BASE_URL + 'api/Combo/GetActivityPageName',
    GET_ACTIVITY_TYPE: this.BASE_URL + 'api/Combo/GetUserActivityType',
    GET_LOCATION: this.BASE_URL + 'api/Combo/GetLocation',
    GET_FILLING_FACILITY_DISPESENER:
      this.BASE_URL + 'api/Combo/GetDispensingUnitFillingFacility',
    GET_TANK: this.BASE_URL + 'api/Combo/GetConnectedTanks',
    GET_GENERATOR: this.BASE_URL + 'api/Combo/GetGeneratorData',
    GET_TANKER: this.BASE_URL + 'api/Combo/GetTanksData',
    GET_ALERT_TYPE: this.BASE_URL + 'api/Combo/GetAlertType',
    GET_VEHICLE_TYPE: this.BASE_URL + 'api/Combo/VehicleType',
    GET_VEHICLE_EMPLOYEE_DATA:
      this.BASE_URL + 'api/Combo/GetAllEmployeeCode',
    GET_FILLING_FACILITY_DATA: this.BASE_URL + 'api/Combo/GetFillingFacility',
    GET_SUPPLIER_DATA: this.BASE_URL + 'api/Combo/GetSupplier',
    GET_CONNECTED_TANKS: this.BASE_URL + 'api/Combo/ConnectedTanks',
    GET_PHONE_MAKE_DATA: this.BASE_URL + 'api/Combo/PhoneMake',
    GET_PHONE_MODEL_DATA: this.BASE_URL + 'api/Combo/PhoneModel',
    GET_IMEI_DATA: this.BASE_URL + 'api/Combo/PhoneIMEI',
    GET_FILLING_STATION: this.BASE_URL + 'api/Combo/GetFDS',
    GET_INTERNAL_NUMBER: this.BASE_URL + 'api/Combo/SimCardDetails',
    GET_TAG_MASTER_TYPE: this.BASE_URL + 'api/Combo/GetTagMasterType',
    GET_OPERATOR_DATA: this.BASE_URL + 'api/Combo/OperatorTagHistory',
    GET_PLANT_DATA: this.BASE_URL + 'api/Combo/GetPlantFleet',
    GET_API_LOG_TYPE: this.BASE_URL + 'api/Combo/GetGraphQLApiDetails',
    GET_TRIGGER_MASTER_DATA: this.BASE_URL + 'api/Combo/GetTriggerTypeCode',
    GET_SUBPRODUCT_FLEET: this.BASE_URL + 'api/Combo/GetSubProductFleetCode',

    //COLUMN-WIDTH
    GET_COLUMN_WIDTH: this.BASE_URL + 'api/List/UpdateColumnWidth',

    //FAVSITES
    GET_FAVSITES: this.BASE_URL + 'api/UserManagement/AddFavouriteSite ',

    //DASHBOARD
    GET_ALL_SITE_COUNT: this.BASE_URL + 'api/Dashboard/GetAllSiteCount',
    GET_TRANSACTION_CATEGORY:
      this.BASE_URL + 'api/Dashboard/TransactionCategory',
    GET_TOP_CONSUME_CATEGORY:
      this.BASE_URL + 'api/Dashboard/Top10ConsumeCategory',
    GET_TOP_CONSUME_REGION:
      this.BASE_URL + 'api/Dashboard/Top10ConsumptionRegions',
    GET_WEEKLY_DISPENSE: this.BASE_URL + 'api/Dashboard/WeeklyDispense',
    GET_DASHBOARD_COUNT: this.BASE_URL + 'api/Dashboard/GetDashboardCount',
    GET_DUMOBILE_TANKERS: this.BASE_URL + 'api/Dashboard/GetDUMobileTanker',
    GET_MOBILE_TANKERS: this.BASE_URL + 'api/Dashboard/GetMobileTanker',
    GET_ATG_MAPPING: this.BASE_URL + 'api/List/GetAtgMapping',
    GET_CLICK: this.BASE_URL + 'api/Dashboard/GetDashboardCountPopup',
    GET_REGION_CLICK: this.BASE_URL + 'api/Dashboard/GetRegionPopUp',
    GET_SECOND_REGION_CLICK:
      this.BASE_URL + 'api/Dashboard/GetRegionPopUpDetail',
    GET_TODAY_FUEL_STOCK_CLICKDATA:
      this.BASE_URL + 'api/Dashboard/GetTodayFuelStockPopUp',
    GET_TODAY_DISPENSED_CLICKDATA:
      this.BASE_URL + 'api/Dashboard/GetTodayDispensePopUp',
    GET_TODAY_TRANSACTION_CLICKDATA:
      this.BASE_URL + 'api/Dashboard/GetTodayTransactionDetail',
    GET_TODAY_SERVED_CLICKDATA:
      this.BASE_URL + 'api/Dashboard/GetTodayServedFleetPopUp',

    //USER PAGE
    GET_USERLIST: this.BASE_URL + 'api/UserManagement/UserList',
    GET_USER_STATUS_UPDATE:
      this.BASE_URL + 'api/UserManagement/UpdateUserStatus',
    GET_USER_PROFILE:
      this.BASE_URL + 'api/UserProfile/UserManagement/UserFullInfo',
    GET_USER_EDIT: this.BASE_URL + 'api/UserManagement/EditUserData',
    GET_ADD_UPDATE_USER: this.BASE_URL + 'api/UserManagement/AddUpdateUser',
    GET_USER_OTP_ACCESS: this.BASE_URL + 'api/UserManagement/GetUserOtpAccess',

    //ROLE PAGE
    GET_MASTER_LIST: this.BASE_URL + 'api/RoleMaster/ModuleMasterList',
    GET_ROLE_STATUS_UPDATE: this.BASE_URL + 'api/RoleMaster/UpdateRoleStatus',
    GET_ROLE_LIST: this.BASE_URL + 'api/RoleMaster/RoleModuleList',
    GET_ADD_UPDATE_ROLE: this.BASE_URL + 'api/RoleMaster/AddUpdateRole',
    GET_REODERING_ROLE: this.BASE_URL + 'api/Combo/GetReOrdering',
    ADD_REORDERING_ROLE: this.BASE_URL + 'api/Combo/AddReOrdering',
    GET_REPORT_ALERT_LIST: this.BASE_URL + 'api/Report/ReportAlertList',
    ADD_REPORT_ALERT_ROLE: this.BASE_URL + 'api/Report/AddUpdateRoleAlert',

    //REPORT PAGE
    GET_DISPENSE_REPORT: this.BASE_URL + 'api/Report/GetDispenseReport',
    GET_DISPENSE_CUSTOMER_SALES_REPORT:
      this.BASE_URL + 'api/Report/GetDispenseCustomerSalesReport',
    GET_DISPENSE_MASTERTAG_REPORT:
      this.BASE_URL + 'api/Report/GetDispenseMasterTagReport',
    GET_DISPENSE_TANKCAPACITY_REPORT:
      this.BASE_URL + 'api/Report/GetDispenseTankCapacityReport',
    GET_DISPENSE_TESTINGTAG_REPORT:
      this.BASE_URL + 'api/Report/GetDispenseTestingTagReport',
    GET_AVERAGE_VARIATIONS_REPORT:
      this.BASE_URL + 'api/Report/GetDispenseAverageVariationReport',
    GET_STOCK_TRANSFER_REPORT:
      this.BASE_URL + 'api/Report/GetStockTransferReport',
    GET_SAM_DISPENSE_CURRENT_DATA:
      this.BASE_URL + 'api/Report/GetStockTransferReport',
    GET_ATG_STOCK_REPORT: this.BASE_URL + 'api/Report/GetAtgStockReport',
    GET_ATGMAPPING_STOCK_REPORT: this.BASE_URL + 'api/List/GetATGMappingStockReport',
    GET_DECANTATION_REPORT: this.BASE_URL + 'api/Report/GetDecantationReport',
    DECANTATION_TRANSFER_RECORD: this.BASE_URL + 'api/Report/UpdateDecantationStockTransfer',

    //ATG DASHBOARD
    GET_ATG_DASHBOARD: this.BASE_URL + 'api/Dashboard/GetAtgDashboard',

    // ONBOARD
    GET_ONBOARD_LIST: this.BASE_URL + 'api/List/OnBoardingList',
    GET_ADD_ONBOARD: this.BASE_URL + 'api/List/AddDevice',
    GET_DEBOARD_DEVICE: this.BASE_URL + 'api/List/DeboardDevice',
    GET_UPDATE_ONBOARD: this.BASE_URL + 'api/List/UpdateDevice',
    GET_DISPENSER_MAKE: this.BASE_URL + 'api/Combo/GetDispenserMake',
    GET_DISPENSER_MODEL: this.BASE_URL + 'api/Combo/GetDispenserModel',
    GET_DISPENSER_SUB_PRODUCT:
      this.BASE_URL + 'api/Combo/GetDispenserSubProduct',
    GET_DISPENSER_TYPE: this.BASE_URL + 'api/Combo/GetDispenserType',
    GET_DISPENSER_DEVICE_UID: this.BASE_URL + 'api/Combo/GetDispenserDeviceUid',
    GET_SIM_OPERATOR: this.BASE_URL + 'api/Combo/GetSimOperator',
    GET_FLEET_DETAILS: this.BASE_URL + 'api/Combo/GetFleetDetails',
    ADD_FUEL_CHART: this.BASE_URL + 'api/List/AddFuelChart',
    GET_FUEL_CHART: this.BASE_URL + 'api/List/GetFuelChart',
    GET_ONBOARD_DEBOARD_HISTORY:
      this.BASE_URL + 'api/List/OnBoardingHistoryList',
    GET_EMPLOYEE_DETAILS: this.BASE_URL + 'api/List/GetEmployeeData',
    UPDATE_FUEL_LIMIT: this.BASE_URL + 'api/Alert/SetFuelLimit',

    //CUSTOMER
    GET_CUSTOMER_DATA: this.BASE_URL + 'api/Combo/GetCustomerData',
    GET_CUSTOMER_LIST: this.BASE_URL + 'api/List/CustomerList',
    ADD_UPDATE_CUSTOMER: this.BASE_URL + 'api/List/AddUpdateDeleteCustomer',
    GET_CUSTOMER_LOCATION: this.BASE_URL + 'api/Combo/GetCustomerLocationData',
    //Location
    GET_CUSTOMER_LOCATION_LIST: this.BASE_URL + 'api/List/CustomerLocationList',
    ADD_UPDATE_CUSTOMER_LOCATION:
      this.BASE_URL + 'api/List/AddUpdateDeleteCustomerLocation',
    GET_CUSTOMER_DROPDOWN: this.BASE_URL + 'api/List/CustomerList',

    //ORGANIZATION
    GET_ORGANIZATION_DETAILS: this.BASE_URL + 'api/List/GetCostAccountData',
    GET_OTP_LIST: this.BASE_URL + 'api/List/GetOtpList',

    // TAG INSTALLATIONS
    GET_TAG_MASTER: this.BASE_URL + 'api/Combo/GetTagMaster',
    GET_TAG_TYPE: this.BASE_URL + 'api/Combo/GetTagType',
    GET_FLEET_TAG_ASSIGNMENT: this.BASE_URL + 'api/Combo/GetFleetTagAssignment',
    ADD_NEW_FLEET_TAG: this.BASE_URL + 'api/List/AddFleetTag',
    ADD_UPDATE_TAG_INSTALLATION:
      this.BASE_URL + 'api/List/AddUpdateTagInstallation',
    GET_TAG_LIST: this.BASE_URL + 'api/List/TagInstallationList',
    DELETE_TAG: this.BASE_URL + 'api/List/TagUnassigned',
    TAG_TYPE: this.BASE_URL + 'api/Combo/TagType',
    GET_TAG_HISTORY: this.BASE_URL + 'api/List/TagInstallationHistoryList',

    // Master Tag Installation.
    ADD_MASTER_TAG: this.BASE_URL + 'api/List/AddMasterTag',
    GET_MASTER_TAG_LIST: this.BASE_URL + 'api/List/MasterTagList',
    DOWNLOAD_TAG_EXCEL_FILE: this.BASE_URL + 'api/List/TagExcelDownload',

    // Operator Details.
    GET_OPERATOR_LIST: this.BASE_URL + 'api/List/IButtonList',
    GET_I_BUTTON: this.BASE_URL + 'api/Combo/GetIButton',
    ADD_I_BUTTON: this.BASE_URL + 'api/List/AddIButton',
    DEBOARD_I_BUTTON: this.BASE_URL + 'api/List/DeboardIButton',
    GET_IBUTTON_HISTORY: this.BASE_URL + 'api/List/IButtonHistoryList',

    //TAG LIST
    GET_TAGMASTER_LIST: this.BASE_URL + 'api/List/GetTagMasterlist',
    GET_TAG_DISPENSED_ALLOW: this.BASE_URL + 'api/List/TagDispenseAllowed',

    // Fleet Master.
    GET_FLEET_MASTER_LIST: this.BASE_URL + 'api/List/FleetMasterList',
    GET_FLEET_MASTER_DATA_LIST:
      this.BASE_URL + 'api/List/GetFleetMasterDataList',
    UPDATE_FLEET_MASTER: this.BASE_URL + 'api/List/UpdateFleetMaster',
    TANK_POSITION_MASTER: this.BASE_URL + 'api/Combo/TankPositionMaster',
    UPDATE_FUEL_FIXED: this.BASE_URL + 'api/List/UpdateFuelFixed',

    // COnfiguration.
    GET_WEB_CONFIG_DATA: this.BASE_URL + 'api/List/GetWebConfigData',
    UPDATE_WEB_CONFIG: this.BASE_URL + 'api/List/UpdateWebConfig',

    //UID (Master Page)
    GET_UID_LIST: this.BASE_URL + 'api/List/GetUidListing',
    ADD_DELETE_UID: this.BASE_URL + 'api/List/AddUpdateUid',

    //ATG-Mapping
    ADD_UPDATE_ATG_MAPPING:
      this.BASE_URL + 'api/List/AddUpdateDeleteAtgMapping',
    ATG_MAPPING_CHART: this.BASE_URL + 'api/List/AtgMappingChart',
    ATG_MAPPING_LIST: this.BASE_URL + 'api/List/AtgMappingList',
    GET_ATG_STATUS_UPDATE: this.BASE_URL + 'api/List/UpdateAtgMappingStatus',

    //LOG API
    GET_APPLOG_LIST: this.BASE_URL + 'api/List/AppLogDataList',
    GET_OFFLINELOG_LIST: this.BASE_URL + 'api/List/offlineLogDataList',
    GET_GRAPHQL_API_LOG: this.BASE_URL + 'api/List/GetGraphQlApiLog',
    GET_DIP_LIST: this.BASE_URL + 'api/List/GetDipReadingList',
    GET_USER_ACTIVITY_LIST: this.BASE_URL + 'api/List/GetUserActivityLog',
    GET_EXCEPTION_LOG_LIST: this.BASE_URL + 'api/List/GetExceptionLog',
    GET_ACTIVITY_LOG_LIST: this.BASE_URL + 'api/List/GetUserActivityLogList',
    GET_FUEL_LOG_LIST: this.BASE_URL + 'api/Report/GetFuelData',

    //GENERATE TAG MASTER CSV
    GENERATE_TAG_MASTER_CSV: this.BASE_URL + 'api/List/GenerateTagMasterCsv',

    //DEVICE FORM
    GET_DEVICE_FORM_DATA: this.BASE_URL + 'api/User/GetDeviceFormData',
    ADD_DEVICE_FORM_DATA: this.BASE_URL + 'api/User/InsertDeviceFormData',

    //LISTENER
    GET_RAW_UID: this.BASE_URL + 'api/Combo/GetRawUid',
    GET_RAW_DATA: this.BASE_URL + 'api/List/GetRawData',

    // Fuel Request
    GET_PURPOSE_LIST: this.BASE_URL + 'api/Combo/GetPurposeList',
    GET_FLEET_FOR_FUEL_REQUEST: this.BASE_URL + 'api/Combo/GetFleetRequisition',
    ADD_UPDATE_FUEL_REQUEST:
      this.BASE_URL + 'api/List/AddUpdateFuelRequisition',
    GET_FUEL_REQ_LIST: this.BASE_URL + 'api/List/GetFuelRequisitionList',
    DELETE_FUEL_REQ: this.BASE_URL + 'api/Vehicle/FeulRequisitionInActive',
    // Fuel Price
    GET_FUEL_PRICE_LIST: this.BASE_URL + 'api/List/GetPriceList',
    UPDATE_PRICE_LIST: this.BASE_URL + 'api/List/UpdatePriceList',
    GET_SAPTRANSACTION_LIST: this.BASE_URL + 'api/List/SapTransactionLogList',
    GET_SUMMARY_SAPLIST: this.BASE_URL + 'api/List/SapTransactionLogSummary',

    //Location
    GET_LOCATION_LIST: this.BASE_URL + 'api/List/GetLocationList',
    ADD_UPDATE_LOCATION: this.BASE_URL + 'api/List/AddUpdateLocation',

    //Filling Facility
    GET_FILLING_FACILITY_LIST: this.BASE_URL + 'api/List/GetFillingFacilityList',
    ADD_UPDATE_FILLING_FACILITY: this.BASE_URL + 'api/List/AddUpdateFillingFacility',

    //Rename Column
    GET_TABLE_HEADER_DATA: this.BASE_URL + 'api/Combo/DataTableHeaderSearch',
    GET_DATATABLE_HEADER_LIST: this.BASE_URL + 'api/List/GetDataTableHeaderList',
    GET_UPDATE_DATATABLE_HEADER: this.BASE_URL + 'api/List/UpdateDataTableHeader',

    //supplier
    GET_SUPPLIER_LIST: this.BASE_URL + 'api/List/SupplierList',

    //Model
    GET_MODEL_LIST: this.BASE_URL + 'api/Vehicle/GetVehicleModelList',
    ADD_UPDATE_MODEL: this.BASE_URL + 'api/Vehicle/AddUpdateVehicleModel',
    GET_MODEL_STATUS_UPDATE: this.BASE_URL + 'api/Vehicle/UpdateVehicleModelStatus',

    //Make
    GET_MAKE_LIST: this.BASE_URL + 'api/Vehicle/GetVehicleMakeList',
    ADD_UPDATE_MAKE: this.BASE_URL + 'api/Vehicle/AddUpdateVehicleMake',
    GET_MAKE_STATUS_UPDATE: this.BASE_URL + 'api/Vehicle/UpdateVehicleMakeStatus',

    //Vehicles
    GET_VEHICLES_LIST: this.BASE_URL + 'api/Vehicle/GetVehicleDetailsList',
    ADD_UPDATE_VEHICLES: this.BASE_URL + 'api/Vehicle/AddUpdateVehicleDetails',
    GET_VEHICLES_STATUS_UPDATE: this.BASE_URL + 'api/Vehicle/UpdateVehicleDetailsStatus',
    GET_VEHICLES_MAKE_LIST: this.BASE_URL + 'api/Combo/VehicleMake',
    GET_VEHICLES_MODEL_LIST: this.BASE_URL + 'api/Combo/VehicleModel',

    //Command Center
    GET_COMMAND_LIST: this.BASE_URL + 'api/Combo/GetCommand',
    GET_COMMAND_HISTORY_LIST: this.BASE_URL + 'api/List/CommandHistoryList',
    GET_COMMAND_FLEET_LIST: this.BASE_URL + 'api/List/CommandFleetList',
    SEND_COMMAND: this.BASE_URL + '/api/List/SendCommand',
    CANCEL_COMMAND: this.BASE_URL + '/api/List/CancelCommand',

    //Alert
    ADD_UPDATE_ALERT: this.BASE_URL + 'api/List/AddCommentToAlert',
    MANAGE_ALERT: this.BASE_URL + 'api/List/ManageAlerts',
    GET_ALERT_LIST: this.BASE_URL + 'api/Alert/GetAlertList',
    UPDATE_ALERT_STATUS: this.BASE_URL + 'api/Alert/UpdateAlertReadStatus',
    GET_COMMENT_LIST: this.BASE_URL + 'api/Alert/GetCommentList',
    ADD_COMMENT_TO_ALERT: this.BASE_URL + 'api/Alert/AddAlertComment',
    TODAY_ALERT_LIST: this.BASE_URL + 'api/Alert/GetTodaysAlertList',

    //Diesel Supply
    GET_DIESEL_SUPPLY_LIST: this.BASE_URL + 'api/List/GetDieselSupplyList',
    ADD_UPDATE_DIESEL_SUPPLY: this.BASE_URL + 'api/List/AddUpdateDieselSupply',
    GET_COUNTER_QTY: this.BASE_URL + 'api/Vehicle/GetDecantationSaleLtr',

    //SIM CARD
    GET_SIM_CARD_LIST: this.BASE_URL + 'api/Sim/GetSimDetailsList',
    ADD_UPDATE_SIM_CARD: this.BASE_URL + 'api/Sim/AddUpdateSimDetails',

    //PHONE MAKE
    GET_PHONE_MAKE_LIST: this.BASE_URL + 'api/Sim/GetPhoneMakeList',
    ADD_UPDATE_PHONE_MAKE: this.BASE_URL + 'api/Sim/AddUpdatePhoneMake',

    //PHONE MODEL
    ADD_UPDATE_PHONE_MODEL: this.BASE_URL + 'api/Sim/AddUpdatePhoneModel',
    GET_PHONE_MODEL_LIST: this.BASE_URL + 'api/Sim/GetPhoneModelList',


    // PHONE ASSIGMENT
    GET_PHONE_ASSIGNMENT_LIST: this.BASE_URL + 'api/Sim/GetPhoneAssignmentList',
    ADD_UPDATE_PHONE_ASSIGNMENT: this.BASE_URL + 'api/Sim/AddUpdatePhoneAssignment',
    GET_PHONE_ASSIGNMENT_STATUS_UPDATE: this.BASE_URL + 'api/Sim/StatusUpdatePhoneAssignment',

    //PHONE DETAILS
    GET_PHONE_DETAILS_LIST: this.BASE_URL + 'api/Sim/GetPhoneIMEIList',
    ADD_UPDATE_PHONE_DETAILS: this.BASE_URL + 'api/Sim/AddUpdatePhoneIMEI',
    GET_PHONE_DETAILS_STATUS_UPDATE: this.BASE_URL + 'api/Sim/StatusUpdatePhoneIMEI',

    //NOTIFICATION HUB
    NOTIFICATION_HUB: this.BASE_URL + 'api/hubs/alerts',

    //Calibration Request
    GET_CALIBRATION_REQUEST_LIST: this.BASE_URL + 'api/CalibrationRequest/GetCalibrationRequestList',
    CALIBRATION_APPROVE_REJECT_REQUEST: this.BASE_URL + 'api/CalibrationRequest/CalibrationApproveRejectRequest',

    //PROJECT MASTER
    GET_PROJECT_MASTER_LIST: this.BASE_URL + 'api/List/GetProjectMasterData',

    ///FDS Notification
    GET_FDS_NOTIFICATION_LIST: this.BASE_URL + 'api/List/GetFdsNotificationList',

    //Email Alert
    GET_EMAIL_ALERT_LIST: this.BASE_URL + 'api/Alert/EmailAlertList',
    ADD_UPDATE_EMAIL_ALERT: this.BASE_URL + 'api/Alert/UpdateEmailAlertPermission',
  };

}
